import {ChangeDetectorRef, Component, Inject, ViewChild} from "@angular/core";
import {NgForm} from "@angular/forms";
import {FelloVisitorVariables} from "fello-model";
import {QuestionCardDirective} from "../../../directives/question-card/question-card.directive";
import {FELLO_JOURNEY_TASK_ID} from "../../../injection-token";
import {OfferJourneyService} from "../../../services/offer-journey/offer-journey.service";
import {FormatNumberShorthandUtil} from "fello-common";

@Component({
  selector: "app-que-home-cost",
  templateUrl: "./que-home-cost.component.html",
  styleUrls: ["./que-home-cost.component.scss"]
})
export class QueHomeCostComponent extends QuestionCardDirective {
  homeWorth: string;
  approxHomeWorth: number;
  homeWorthExactAmount: number;
  @ViewChild("exactAmount") exactAmount?: NgForm;

  constructor(
    public offerJourneyService: OfferJourneyService,
    @Inject(FELLO_JOURNEY_TASK_ID) public taskId: string,
    private cd: ChangeDetectorRef
  ) {
    super(offerJourneyService, taskId);
  }

  get upperRange(): string {
    const low = FormatNumberShorthandUtil.transform(this.approxHomeWorth * 0.97);
    const range = "Between " + low + " - " + FormatNumberShorthandUtil.transform(this.approxHomeWorth * 1.02);
    return range;
  }

  get lowerRange(): string {
    const low = FormatNumberShorthandUtil.transform(this.approxHomeWorth * 0.9);
    const range = "Between " + low + " - " + FormatNumberShorthandUtil.transform(this.approxHomeWorth * 0.96);
    return range;
  }

  ngOnInit(): void {
    if (this.offerJourney.vars._a != null && this.offerJourney.vars._a > 0) {
      this.approxHomeWorth = this.offerJourney.vars._a;
    } else {
      this.editMode = true;
      this.cd.detectChanges();
    }
    this.homeWorth = this.offerJourney.vars.homeWorth ?? "";
    if (Number(this.offerJourney.vars.homeWorth)) {
      this.homeWorthExactAmount = Number(this.offerJourney.vars.homeWorth);
      this.editMode = true;
      this.cd.detectChanges();
    }
  }

  submit(homeWorth: string | number): void {
    const vars: FelloVisitorVariables = {
      homeWorth: homeWorth as string
    };
    this.offerJourneyService.pushOfferJourneyTask(this.taskId, vars).subscribe();
  }

  toggleEdit(): void {
    this.editMode = !this.editMode;
    this.cd.detectChanges();
  }
}
